export const objectsMatch = (
  obj1: Record<string, unknown>,
  obj2: Record<string, unknown>,
): boolean => JSON.stringify(obj1) === JSON.stringify(obj2);
